export enum SortTypes {
  AlphabeticalAscending = 'AlphabeticalAscending',
  AlphabeticalDescending = 'AlphabeticalDescending',
  DatePublishedAscending = 'DatePublishedAscending',
  DatePublishedDescending = 'DatePublishedDescending',
  SuggestedPostDateAscending = 'SuggestedPostDateAscending',
  SuggestedPostDateDescending = 'SuggestedPostDateDescending'
}
